import { createContext, useContext, type ReactElement } from 'react';
import { useParams } from 'react-router';
import { parseMatrixSegment } from '@/core/routing/matrix';

/** The route param every matrix-capable group uses (see core/routing/matrix.ts for why). */
export const MATRIX_PARAM = 'matrixSegment';

const MatrixContext = createContext<Record<string, string>>({});

/**
 * Mounts the screens of a group that take Angular-style matrix params ("addClient;id=..."). React Router matches
 * the whole `addClient;id=...` segment as one param; this picks the screen by its name and exposes the params.
 * An unknown name renders nothing, like Angular's blank outlet.
 */
export function MatrixSwitch({ table }: { table: Record<string, ReactElement> }) {
  const segment = useParams()[MATRIX_PARAM];
  const { name, params } = parseMatrixSegment(segment);
  const element = Object.hasOwn(table, name) ? table[name] : null;
  return <MatrixContext.Provider value={params}>{element}</MatrixContext.Provider>;
}

/** The matrix params of the current screen (Angular `ActivatedRoute.paramMap` for a segment with matrix params). */
export function useMatrixParams(): Record<string, string> {
  return useContext(MatrixContext);
}
